import React from 'react'
import { GlobalDataContext, useCashflowStore } from '../../common'

export const useCashflowUiStore = () => {
  const context = React.useContext(GlobalDataContext)

  if (!context) {
    throw new Error('useCashflowUiStore() must be used within the GlobalDataContext')
  }

  return useCashflowStore().uiStore
}
